/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type PageContextType } from '@/next-types';
import { type NextApiRequest } from 'next';
import { type ParsedUrlQuery } from 'querystring';
import { getContentByContentType } from '../common/getContentByContentType';
import { type ContentStackPost } from '../../interface/content-types';
import { type FormattedContentStackPost } from '../../interface/models';
import { LANDING_PAGE_FIELDS } from '../landingPage/getContentStackLandingPageContent';

export const getContentStackBlogContent = async (
  req: NextApiRequest | PageContextType['req'],
  query: ParsedUrlQuery,
): Promise<FormattedContentStackPost> => {
  const response = await getContentByContentType<ContentStackPost>({
    contentTypeUid: 'post',
    referenceFieldPath: [
      'title',
      'url',
      'post_type',
      'post_attributes',
      'feature_image_video',
      'taxonomies',
      'post_content',
      'faq_fields',
      'seo',
      'post_content.landingpage_component',
      'uid',
      ...LANDING_PAGE_FIELDS.map(
        (field) => `post_content.landingpage_component.component.${field}`,
      ),
      'post_content.pencil_banner.pencil_banner',
      'reviewer',
      'certona',
    ],
    referenceFieldOnly: {
      reviewer: ['title', 'post_review', 'url'],
    },
    req,
    query,
    customizeQuery: ({ query, queryParams }) => {
      if (typeof queryParams?.blogPath === 'string' && queryParams?.blogPath !== '') {
        query.where('url', queryParams.blogPath);
      }

      return query;
    },
  });

  return { blogContent: response };
};
